import React, { type FC } from "react";

import { Icon, type IconProps } from "../../../Icon";

import classes from "./ToastIcon.styl";

const TOAST_ICON_TEST_ID = "toast-icon-test-id";

interface IToastIcon {
    size?: IconProps["size"];
    icon?: IconProps["icon"];
}

const ToastIcon: FC<IToastIcon> = (props) => {
    return (
        <Icon
            className={classes["icon"]}
            {...(props as IconProps)}
            data-tsid={TOAST_ICON_TEST_ID}
        />
    );
};

ToastIcon.displayName = "Toast.ToastIcon";

export default ToastIcon;
